import React from 'react';
import { type RestSeventyThirtyRowModal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import G2Badge from './g2_badge';
import Quote from './quote';

type Props = {
  info: RestSeventyThirtyRowModal['requires']['hero'];
};
const ModalMultiQuoteTop: React.FC<Props> = (props) => {
  const { info: hero } = props;

  const renderQuotes = () => {
    // Due to design, this needs to be very specific
    // Four quotes
    // Limits on quote text
    const gridItems = hero.quotes.slice(0, 4).map((qt, idx) => (
      // Calculate styles for the grid item
      <Quote info={qt} class={`quad${idx + 1}`} key={`quad${idx + 1}`} />
    ));

    return (
      <div className="quote-grid quote-group">
        {/* 65 / 35 column split */}
        <div className="grid1">
          {/* 65 side: 4 25% columns, unique spans */}
          <div className="grid2">
            <div className="g2-row-top">
              {gridItems[0]}
              {gridItems[1]}
            </div>
            <div className="g2-row-bottom">{gridItems[2]}</div>
          </div>
          {gridItems[3]}
        </div>
      </div>
    );
  };

  return (
    <div className="modal-multi-quote">
      <div className="MMQContainer">
        {renderQuotes()}
        {hero.g2_rating && <G2Badge gRating={hero.g2_rating} />}
      </div>
    </div>
  );
};

export default ModalMultiQuoteTop;
